import { User } from '../../../models/user';

export class LoadUserProfilePicture {
  static readonly type = '[User] - Load User Profile Picture';

  constructor(public user: User) { }
}

export class LoadProfilePicture {
  static readonly type = '[User] - Load Profile Picture';

  constructor(public userId: string) { }
}

export class SaveUser {
  static readonly type = '[User] - Save User';

  constructor(public user: User) { }
}

export class GetUser {
  static readonly type = '[User] - Get User';

  constructor(public userId: string) { }
}
